import { Grid } from '@mui/material';
import AcademicsLibraryGrid from './academicsLibraryGrid.view';
import AddEditLibraryBorrowingRecordView from './addEditLibraryBorrowingRecord.view';
import AddEditLibraryItemView from './addEditLibraryItem.view';

const AcademicsLibrary = () => {
  return (
    <Grid
      container
      spacing={{ xs: 1, sm: 2 }}
      sx={{ p: { xs: 1, sm: 2 } }}
      data-testid="academics-library-container"
    >
      <Grid item xs={12}>
        <AcademicsLibraryGrid />
      </Grid>
      <AddEditLibraryBorrowingRecordView />
      <AddEditLibraryItemView />
    </Grid>
  );
};

export default AcademicsLibrary;
